import React, { FC } from 'react'
import styled from 'styled-components'

import Check from '@Assets/SVG/Check'
import { SVGIcon } from '@Components/Icons'
import { Modal, SharedModalProps } from '@Components/Modal'
import { modalMessage } from '@Globals/Style/mixins'
import { useTranslation } from '@Globals/Translations'

const Icon = styled.div(({ theme }) => ({
  alignItems: 'center',
  border: `1px solid ${theme.colors.primary}`,
  borderRadius: '50%',
  display: 'flex',
  height: 80,
  justifyContent: 'center',
  margin: '0 auto 10px',
  padding: 12,
  width: 80,
}))

const Message = styled.div`
  ${modalMessage}
`

type FeedbackModalProp = SharedModalProps & {
  secondaryText?: string
  text: string
}

export const FeedbackModal: FC<FeedbackModalProp> = ({
  isOpen, onHide, secondaryText = '', text,
}) => {
  const { t } = useTranslation()

  return (
    <Modal button="close" isOpen={isOpen} onHide={onHide} variant="default">
      <Message>
        <Icon>
          <SVGIcon color="primary" icon={Check} size="32px" />
        </Icon>
        <p className="title">{t('common:THANK_YOU')}</p>
        <p>{text}</p>
        {secondaryText && <p>{secondaryText}</p>}
      </Message>
    </Modal>
  )
}
